<template>
	<div class="home">
		<el-skeleton v-if="pageloading">
			<template slot="template">
				<el-skeleton-item variant="image" class="skeleton-banner" />
				<div class="layui-container">
					<el-row :gutter="15">
						<el-col :span="8" v-for="(item,index) in 3">
							<div class="menu-link-skeleton">
							<el-skeleton-item variant="image" class="menu-icon-skeleton" />
							<el-skeleton-item variant="p"  style="margin-top: 10px;"/>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="layui-container">
					<div class="skeleton-title">
						<el-skeleton-item variant="h1"  />
						<el-skeleton-item variant="p"  />
					</div>
					<el-row :gutter="15">
						<el-col :xs="12" :span="8" v-for="(item,index) in 3">
							<div class="sk-product">
								<el-skeleton-item variant="image" class="skeleton-sk-photo" />
								<el-skeleton-item variant="p" style="margin-top: 10px;" />
								<el-skeleton-item variant="p"  style="margin-top: 10px;"/>
								<el-skeleton-item variant="p"  style="margin-top: 10px;"/>
							</div>
						</el-col>
						
					</el-row>
				</div>
				
			</template>
		</el-skeleton>
		<div class="home-main" v-else>
			<van-nav-bar fixed placeholder z-index="99" :border="false" v-if="isMobileFlag">
				<template #left>
					<span class="iconfont icon-menu" v-if="$store.state.isLoginStatu" @click="onMenu"></span>
				</template>
				<template #title>
					<div class="index-logo"><img :src="$helper.get('rule').app_logo" alt="" /></div>
				</template>
				<template #right>
					<ul class="nav-menu nav-enter-menu" v-if="false">
						<li>
							<router-link to="/Login">
								<span class="iconfont icon-user"></span><span>{{$t('登录')}}</span>
							</router-link>
						</li>
						<li>
							<router-link to="/Register">
								<span class="iconfont icon-invte"></span><span>{{$t('注册')}}</span>
							</router-link>
						</li>
					</ul>
					<ul class="nav-menu nav-menu-link">
						<li>
							<router-link to="/ucenter" class="user-box">
								<img src="../../assets/images/head.png" alt="" />
							</router-link>
						</li>
						<li>
							<router-link to="/cart">
								<el-badge is-dot class="item">
									<span class="iconfont icon-cart"></span>
								</el-badge>
							</router-link>
						</li>
						<li v-if="!$store.state.isLoginStatu ">
							<router-link to="/my-order">
								<span class="iconfont icon-order"></span>
							</router-link>
						</li>
					</ul>
				</template>
			</van-nav-bar>
			<Banner />
			<MenuFluid />
			<EnterLink />
			<div class="index-wrapper" v-if="allProducts">
				<Hot :item="allProducts" />
				<!-- <Discount :item="allProducts"/> -->
			</div>
			<Foot v-if="isMobileFlag" :active="0" />
			<!-- 菜单 -->
			<AsideMenu ref="AsideMenu"></AsideMenu>
		</div>
	</div>
</template>
<script>
	import AsideMenu from "@/components/AsideMenu.vue";
	import Foot from "@/components/Foot.vue";
	import Banner from './components/Banner.vue'
	import EnterLink from './components/EnterLink.vue'
	import Hot from './components/Hot.vue'
	import MenuFluid from './components/MenuFluid.vue'
	import News from './components/News.vue'
	import Discount from './components/Discount.vue'
	import Cooperation from './components/Cooperation.vue'
	import {
		index_goods_list_api
	} from "@/api/index"
	export default {
		components: {
			AsideMenu,
			Foot,
			Banner,
			EnterLink,
			Hot,
			MenuFluid,
			News,
			Discount,
			Cooperation
		},
		data() {
			return {
				allProducts: null,
				pageloading: true,
			};
		},
		methods: {
			onMenu(){
				this.$refs.AsideMenu.show = true
			},
			async getGoodsData() {
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				try {
					const res = await index_goods_list_api();
					if (res && res.data.code == 1) {
						this.allProducts = res.data.data.lists;
						loading.close();
						this.pageloading = false
					}
				} catch (error) {
					console.error('获取商品数据失败', error);
				}
			},
		},
		mounted() {
			this.getGoodsData()
		}
	}
</script>
<style scoped>
	.user-box {
		display: block;
		font-size: 0;
		line-height: 1;
	}

	.user-box img {
		width: 30px;
		height: 30px;
		border-radius: 30px;
	}

	.index-logo {
		font-size: 0;
	}

	.index-logo img {
		height: 32px;
		display: block;
	}
</style>